import { memo } from "react";

const Footer = () => {
    
}

export default memo(Footer);